import { useQuery } from "@tanstack/react-query";
import api from "../utils/api";

export const fetchGetTAs = async ({ studyId, keyword }) => {
  const params = new URLSearchParams();

  // studyId와 keyword가 있으면 쿼리 파라미터에 추가합니다.
  if (studyId) {
    params.append("studyId", studyId);
  }
  if (keyword) {
    params.append("q", keyword); // 'q'는 일반적으로 검색 쿼리를 나타내는 파라미터입니다.
  }

  // 쿼리 파라미터가 추가된 URL로 API를 호출합니다.
  return await api.get(`/admin/ta?${params.toString()}`);
};

export const useGetTAsQuery = ({ studyId, keyword }) => {
  return useQuery({
    queryKey: ["tas", studyId, keyword],
    queryFn: () => fetchGetTAs({ studyId, keyword }),
    select: (data) => {
      return data.data.data;
    },
    keepPreviousData: true,
  });
};
